export var Direction;
(function (Direction) {
    Direction[Direction["top"] = 0] = "top";
    Direction[Direction["right"] = 1] = "right";
    Direction[Direction["grid"] = 2] = "grid";
    Direction[Direction["bottom"] = 3] = "bottom";
    Direction[Direction["left"] = 4] = "left";
    Direction[Direction["grid2"] = 5] = "grid2";
})(Direction || (Direction = {}));
